/* RESPONSIBLE TEAM: team-fin-voice */
/* eslint-disable @intercom/intercom/no-bare-strings */
import type { FinVoiceVoiceLanguage } from 'embercom/objects/ai-agent/fin-voice/fin-voice-language-options';

const ELEVENLABS_TO_CARTESIA_FALLBACK: Record<string, string | Record<string, string>> = {
  Mark: {
    default: 'Chandler',
    ar: 'Hassan',
    cs: 'Petr',
    da: 'Soren',
    de: 'Sebastian',
    en: 'Chandler',
    es: 'Benito',
    fr: 'Antoine',
    hi: 'Sagar',
    hu: 'Gabor',
    it: 'Lucio',
    ja: 'Daisuke',
    ko: 'Byungtae',
    nl: 'Bram',
    no: 'Lars',
    pl: 'Wojciech',
    pt: 'Tiago',
    ro: 'Andrei',
    ru: 'Dmitri',
    sv: 'Erik',
    ta: 'Arun',
    tr: 'Emre',
    uk: 'Oleh',
  },
  Juniper: {
    default: 'Jacqueline',
    ar: 'Nour',
    cs: 'Petr',
    da: 'Soren',
    de: 'Alina',
    en: 'Jacqueline',
    fr: 'Eloise',
    hi: 'Riya',
    it: 'Giulia',
    pl: 'Katarzyna',
    pt: 'Beatriz',
    ro: 'Andrada',
    tr: 'Leyla',
  },
  Cassidy: 'Jacqueline',
  Hope: {
    default: 'Jacqueline',
    bg: 'Ivana',
    cs: 'Petr',
    el: 'Nikos',
    en: 'Jacqueline',
    es: 'Alondra',
    fr: 'Eloise',
    hi: 'Riya',
    hu: 'Gabor',
    it: 'Giulia',
    pt: 'Beatriz',
    ro: 'Andrada',
    ru: 'Tatiana',
    tr: 'Leyla',
  },
  Chris: {
    default: 'Rupert',
    bg: 'Ivana',
    cs: 'Petr',
    el: 'Nikos',
    en: 'Rupert',
    es: 'Benito',
    fi: 'Mikko',
    fr: 'Antoine',
    hu: 'Gabor',
    ja: 'Daisuke',
    ko: 'Byungtae',
    nl: 'Bram',
    no: 'Lars',
    pl: 'Wojciech',
    ru: 'Dmitri',
    sv: 'Erik',
    ta: 'Arun',
    tr: 'Emre',
  },
  Nichalia: {
    default: 'Jacqueline',
    cs: 'Petr',
    de: 'Alina',
    el: 'Nikos',
    en: 'Jacqueline',
    es: 'Alondra',
    fi: 'Mikko',
    fr: 'Eloise',
    hi: 'Riya',
    hu: 'Gabor',
    it: 'Giulia',
    ko: 'Byungtae',
    pl: 'Katarzyna',
    pt: 'Beatriz',
    ro: 'Andrada',
    ru: 'Tatiana',
    sv: 'Freja',
    ta: 'Kavya',
    tr: 'Leyla',
    zh: 'Shuwen',
  },
  Archer: {
    default: 'Alistair',
    da: 'Soren',
    el: 'Nikos',
    en: 'Alistair',
    es: 'Benito',
    fr: 'Antoine',
    hi: 'Sagar',
    hu: 'Gabor',
    it: 'Lucio',
    nl: 'Bram',
    pl: 'Wojciech',
    pt: 'Tiago',
    ro: 'Andrei',
    ru: 'Dmitri',
    sv: 'Erik',
    ta: 'Arun',
    tr: 'Emre',
  },
  Alexander: 'Rupert',
  Paul: {
    default: 'Barry',
    cs: 'Petr',
    da: 'Soren',
    el: 'Nikos',
    en: 'Barry',
    es: 'Benito',
    fr: 'Antoine',
    hi: 'Sagar',
    hu: 'Gabor',
    it: 'Lucio',
    nl: 'Bram',
    pl: 'Wojciech',
    pt: 'Tiago',
    ru: 'Dmitri',
    sv: 'Erik',
    tr: 'Emre',
  },
  Hannah: 'Eleanor',
  Imogen: 'Victoria',
  Labhaoise: 'Jacqueline',
  Rory: 'Blake',
  Chelsea: 'Jacqueline',
  Sully: {
    default: 'Blake',
    ar: 'Hassan',
    bg: 'Ivana',
    cs: 'Petr',
    de: 'Sebastian',
    el: 'Nikos',
    en: 'Blake',
    es: 'Benito',
    fr: 'Antoine',
    hi: 'Sagar',
    it: 'Lucio',
    ja: 'Daisuke',
    nl: 'Bram',
    pt: 'Tiago',
    ru: 'Dmitri',
    sv: 'Erik',
    tr: 'Emre',
    uk: 'Oleh',
  },
  Jerry: 'Blake',
  Oxley: 'Blake',
  Lydia: 'Mary',
  Jack: 'Blake',
  Alan: 'Blake',
  April: 'Jacqueline',
  Carolina: 'Alondra',
  Ruiz: 'Alondra',
  Dora: 'Daniela',
  Lizy: 'Daniela',
  Paloma: 'Daniela',
  Jessica: 'Catalina',
  Ana: 'Daniela',
  Linda: 'Catalina',
  Søren: 'Soren',
  Matias: 'Soren',
  Ruth: 'Anneke',
  Serge: 'Bram',
  Arjen: 'Bram',
  Nicolas: 'Antoine',
  Lucie: 'Eloise',
  Alexandre: 'Pierre',
  Susi: 'Alina',
  Felix: 'Sebastian',
  Ramona: 'Alina',
  Lea: 'Alina',
  Pawel: 'Wojciech',
  Konwersacyjny: 'Wojciech',
  Beata: 'Katarzyna',
  Violetta: { default: 'Giulia', es: 'Alondra' },
  Raffaele: 'Lucio',
  Salma: { default: 'Nour', en: 'Jacqueline' },
  Haytham: 'Hassan',
  Saud: 'Hassan',
  'Han Aim': 'Byungtae',
  'Harry Kim': 'Byungtae',
  Kaori: 'Aiko',
  Satoshi: 'Daisuke',
  Helge: 'Lars',
  Johannes: 'Lars',
  Sanna: 'Freja',
  Ola: 'Erik',
  Tommy: 'Erik',
  Eva: 'Freja',
  Jonas: 'Erik',
  Olivia: 'Freja',
  Arcadays: 'Dmitri',
  Olga: 'Tatiana',
  Amy: 'Shuwen',
  Yu: 'Hao',
  'Tong Wong': 'Hao',
  'Anna Su': 'Shuwen',
  Anjali: { default: 'Riya', de: 'Alina' },
  Raju: 'Sagar',
  Putra: 'Andi',
  Zephlyn: 'Siti',
  Orbay: 'Emre',
  'Meta Ecem': 'Leyla',
  Mariya: 'Oleh',
  Alex: 'Oleh',
  'Nguyễn Luci': 'Linh',
  Huyen: 'Linh',
  Milena: 'Ivana',
  Adam: { default: 'Petr', sv: 'Erik' },
  Oliver: 'Petr',
  Theos: 'Nikos',
  Christos: 'Nikos',
  Mike: 'Andrei',
  Anca: 'Andrada',
  Athira: 'Aisyah (Cartesia)',
  Aisyah: { default: 'Aisyah (Cartesia)', en: 'Jacqueline' },
  Nolen: 'Gabor',
  David: 'Gabor',
  Jaakko: 'Mikko',
  Dinis: 'Tiago',
  Roberta: 'Luana',
  Kaique: 'Heitor',
  default: {
    default: 'Rupert',
    da: 'Soren',
    el: 'Nikos',
    en: 'Rupert',
    es: 'Benito',
    fr: 'Antoine',
    hi: 'Sagar',
    hu: 'Gabor',
    it: 'Lucio',
    nl: 'Bram',
    pl: 'Wojciech',
    pt: 'Tiago',
    ro: 'Andrei',
    ru: 'Dmitri',
    sv: 'Erik',
    ta: 'Arun',
    tr: 'Emre',
  },
};

export function getCartesiaFallbackVoiceName(
  elevenLabsVoice: string,
  language: FinVoiceVoiceLanguage,
): string | null {
  if (!language) {
    return null;
  }

  let fallback =
    ELEVENLABS_TO_CARTESIA_FALLBACK[elevenLabsVoice] ?? ELEVENLABS_TO_CARTESIA_FALLBACK['default'];

  let langCode = language.split('-')[0];

  if (typeof fallback === 'string') {
    return fallback;
  }

  return fallback[langCode] ?? fallback['default'] ?? null;
}
